import { compose } from 'redux';
import { connect } from 'react-redux';
import DazeModelScrollView from '../modelScroll/DazeModelScrollView';
import selectors from '../../../rootSelectors';
import { fetchDazeContent, setDazeScreenMode } from '../../dazeActions';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { DAZE_INSTRUCTIONS } from '../../dazeConstants';
import { stopAudio } from '../../../common/audio/audioActions';
import {
    blockScreen, unblockScreen, unmountScreen, activateNextButton,
} from '../../../common/screen/screenActions';
import { goToCountdown } from '../../../common/navigation/navigationActions';
import { DAZE } from '../../../constants/measure';
import { SCROLL, MODE } from '../../../constants/assessmentItemType';
import { highlightCorrectResponses } from '../modelScroll/DazeModelScrollActions';
import { narrateReadyScript }
    from './DazeInstructionsActions';
import { NO_SCROLL_ANIMATION_DURATION } from '../../../constants/slider';

const AVATAR_INSTRUCTIONS = [
    DAZE_INSTRUCTIONS[SCROLL].scrollInstruction,
    DAZE_INSTRUCTIONS[SCROLL].scrollReadyClickOk,
];

const mapStateToProps = (state) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isGreyedOut: selectors.getIsScreenGreyedOut(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isDataFetched: selectors.getIsDazeDataFetched(state),
    isDownButtonHighlighted: selectors.getIsDownButtonHighlighted(state),
    isScrollButtonClicked: selectors.getIsScrollButtonClicked(state),
    isOkButtonGreyedOut: selectors.getIsOkButtonGreyedOut(state),
    paragraphs: selectors.getDazeParagraphs(state, SCROLL),
    questions: selectors.getDazeQuestionItems(state, SCROLL),
    title: selectors.getDazeTitle(state, SCROLL),
    selectedResponses: selectors.getDazeSelectedResponses(state),
    screenMode: selectors.getDazeScreenMode(state),
    scrollDuration: NO_SCROLL_ANIMATION_DURATION,
});

const mapDispatchToProps = (dispatch) => ({
    fetchContent: () => {
        dispatch(fetchDazeContent());
        dispatch(setDazeScreenMode(MODE.READY));
    },
    initModelScrollScreen: () => {
        dispatch(highlightCorrectResponses());
    },
    readyScript: () => {
        dispatch(blockScreen());
        dispatch(activateNextButton());
        return dispatch(narrateReadyScript())
            .then(() => {
                dispatch(unblockScreen());
            });
    },
    onNext: () => {
        dispatch(goToCountdown(DAZE));
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(unmountScreen());
    },
});

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.MIDDLE_LEFT,
    instructions: AVATAR_INSTRUCTIONS,
});

const DazeInstructionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(DazeModelScrollView);

export default DazeInstructionsContainer;
